import './App.css';


import Project from './components/Project'
import Nav from './components/Nav'


function App() {
  return (
    <div className="app">
      <div className="container">
        <Nav/>
        <div className="content">
          <h1 className="header">Project Portfolio</h1>
          <div className="info-container">
            <div><span className='bold'>Name: </span>Magnus Siegumfeldt</div>
            <div><span className='bold'>Contact:</span> mail@maksi.dev</div>
            <div><span className='bold'>Location:</span> Copenhagen, Denmark</div>
          </div>
          {/*<h2 className="section-title">Projects</h2>*/}
          <div className="project-container">
            <Project 
              title={"1. Master Thesis: Algorithms for Snake"} 
              description={"This project accompanies my top-grade master's thesis. My thesis presents a large collection of efficient data structures, with this project constituting a fully modular engine written in C++. It includes highly optimized implementations - in terms of memory and operation time - of all aproaches presented in the thesis, as well as an extensive benchmarking suite."
              }
              github={"https://github.com/MagnusSiegumfeldt/Master"}
              read={"/assets/Snake.pdf"}
            />
            <Project 
              title={"2. Wordle Web-App"} 
              description={"This project is a fully fledged Wordle web-app implementation built with ReactJS. It supports multiple languages, a challenging hard mode, statistics through the use of cookies, and a polished UI closely matching the original gameplay feel."}
              github={"https://github.com/MagnusSiegumfeldt/wordle"}
              demo={"https://mks-wordle.netlify.app"}
            />

            <Project 
              title={"3. Bachelors Thesis: Splay Top Trees"} 
              description={"This project accompanies my top-grade bachelor's thesis. It is an experimental evaluation of Splay Top Trees: a self-balancing Top Tree-like data structure. The work includes a full C++ implementation along with performance comparisons against alternative data structures."
              }
              github={"https://github.com/MagnusSiegumfeldt/top-trees"}
              read={"/assets/TopTrees.pdf"}
            />

            {/*<Project 
              title={"4. A Last Project"} 
              description={"An experimental evaluation of Splay Top Trees, a dynamic graph data structure. The project accompanies my top-grade bachelors thesis."}
              github={"https://github.com/MagnusSiegumfeldt/top-trees"}
              demo={"/"}
            />*/}
          </div>
          
        </div>
      </div>
    </div>
  );
}

export default App;
